import { CommonResponseModel } from "../../../../../../../../../../../../Models/tableDetailsModel";
import agentsApi from "../../../../../../../../../../agents.api";
import {
    IDownloadDownLineHierarchyRequest,
    IUpdateAgentDownLinesStatusRequest,
} from "./hierarchy.models";

export const UpdateAgentDownLinesStatus = async (payload: IUpdateAgentDownLinesStatusRequest) => {
    const response: CommonResponseModel<string> =
        await agentsApi.UpdateAgentDownLinesStatus.post(payload);
    return response;
};

export const DownloadDownLineHierarchy = async (payload: IDownloadDownLineHierarchyRequest) =>
    agentsApi.DownloadDownLineHierarchy.post(payload);
